import styled from '@emotion/styled';
import { getTranslation } from '@tablecheck/i18n';
import { Button } from '@tablecheck/tablekit-react';
import startCase from 'lodash/startCase';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useSSOProviderData } from 'pages/SignIn/components/useSSOProviderData';
import { doRedirect } from 'utils/auth';
import { STORAGE_KEY_SSO_PROVIDER } from 'utils/constants';

const StyledButton = styled(Button)`
  height: 48px;
  padding: 7px 15px !important;
`;

const ProviderImage = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

export function SSOButton(): JSX.Element | null {
  const [, { language }] = useTranslation();
  const { data: providerData } = useSSOProviderData(
    localStorage.getItem(STORAGE_KEY_SSO_PROVIDER)
  );

  return providerData ? (
    <StyledButton
      id="sso-button"
      data-size="large"
      data-variant="ghost"
      aria-label="SSO button"
      onClick={() => {
        if (providerData) {
          doRedirect(providerData.url);
        }
      }}
    >
      {providerData.logo_image_url ? (
        <ProviderImage
          src={providerData.logo_image_url}
          alt={providerData.key}
        />
      ) : null}
      <span>
        {getTranslation(providerData.name_translations, language) ||
          startCase(providerData.key)}
      </span>
    </StyledButton>
  ) : null;
}
